<template>
  <div class="billing-payment-methods">
    <SeparateLine :top="20" :right="-10" :bottom="20" :left="-10" />

    <div name="billing-method">
      <!-- TITULO DE MODALIDADE DE COBRANÇA -->
      <b-row class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title"
        >
          Modalidade de cobrança
        </PmwHeading>
      </b-row>

      <PmwParagraph
        class="form--subtitle form--subtitle__small"
        size="paragraph-40"
      >
        Deixando este campo sem preencher, utilizaremos os dados do Cadastro do
        Hotel. Caso queira uma modalidade diferente, preencha o campo abaixo.
      </PmwParagraph>

      <b-row v-if="!showModalityInputs" class="form--row">
        <PmwButton
          :hasIcon="true"
          variation="blue-100"
          layout="outline"
          class="form--button"
          @click="showModalityInputs = true"
        >
          Adicionar modalidade
        </PmwButton>
      </b-row>

      <div v-if="showModalityInputs" class="form--row">
        <ModalityInputs
          :fluctuationData="fluctuationData"
          :hidePrePayment="hidePrePayment"
          class="form--row__margin"
          @closeInputs="showModalityInputs = false"
        />
      </div>
    </div>

    <SeparateLine
      v-if="hidePaymentForm && noPixHotelPaymentForms?.length !== 0"
      :top="20"
      :right="-10"
      :bottom="20"
      :left="-10"
    />

    <div
      v-if="hidePaymentForm && noPixHotelPaymentForms?.length !== 0"
      name="payment-method"
    >
      <b-row class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title"
        >
          Forma de pagamento exclusiva
        </PmwHeading>
      </b-row>

      <PmwParagraph
        class="form--subtitle form--subtitle__small"
        size="paragraph-40"
      >
        As opções apresentadas aqui são as formas exclusivas configuradas na aba
        forma de pagamento.
      </PmwParagraph>

      <b-row class="form--row">
        <PmwButton
          v-if="!showPaymentForm"
          :hasIcon="true"
          variation="blue-100"
          layout="outline"
          class="form--button"
          @click="showPaymentFormHandler"
        >
          Adicionar forma de pagamento
        </PmwButton>
      </b-row>

      <div v-if="showPaymentForm" class="form--row">
        <PaymentForms
          :fluctuationData="fluctuationData"
          :hotelPaymentForms="noPixHotelPaymentForms"
          :pixCode="pixCode"
          :onlyPix="fluctuationData.somentePix"
          class="form--row__margin"
          @close-inputs="closePaymentInputs"
        />
      </div>
    </div>

    <SeparateLine :top="20" :right="-10" :bottom="30" :left="-10" />

    <div v-if="showPixSelection" class="pix-payment" name="pix-payment">
      <div class="pix-payment--rate-pix">
        <InputCheckbox
          v-model="fluctuationData.habilitarPagamentoPix"
          :checked="fluctuationData.habilitarPagamentoPix"
          :disabled="disableOnlyPix"
          :inputValue="true"
          :infoIcon="true"
          tooltipMinWidth="410"
          label="Tarifa com pagamento PIX"
          infoText="Esta opção pode vir selecionada nos casos que no hotel esteja habilitado para pix em todas as tarifas. Esta opção determina se esta tarifa permite pagamento com pix ou não."
          name="pixRate"
          class="form--input__checkbox"
          ref="pixCheckbox"
          @input="pixCheckboxHandler"
        />

        <InputCheckbox
          v-if="fluctuationData.habilitarPagamentoPix"
          v-model="fluctuationData.somentePix"
          :checked="fluctuationData.somentePix"
          :inputValue="true"
          label="Somente pix como forma de pagamento nesta tarifa"
          name="onlyPixCheckbox"
          class="form--input__checkbox__big"
          ref="onlyPixCheckbox"
          @input="onlyPixCheckboxHandler"
        />
      </div>

      <PmwParagraph
        v-if="blockPixEdition"
        class="pix-payment--warning"
        size="paragraph-40"
        >Como padrão, foi selecionado dentro da
        <strong>Edição do Hotel</strong>, a ativação via pix em todas as
        tarifas</PmwParagraph
      >
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import ModalityInputs from './ModalityInputs'
import PaymentForms from './PaymentForms'

export default {
  name: 'BillingPaymentMethods',
  components: {
    PmwHeading,
    PmwButton,
    SeparateLine,
    InputCheckbox,
    ModalityInputs,
    PaymentForms,
    PmwParagraph
  },

  props: {
    fluctuationData: Object,

    hotelPaymentForms: {
      type: Array,
      default: () => []
    },

    hotelPaymentType: {
      type: Number,
      default: 0
    },

    /** Define se está habilitado o pagamento com pix */
    pixRate: {
      type: Boolean,
      default: false
    },

    /** Bloqueia a edição do pagamento com pix */
    blockPixEdition: Boolean,

    hidePrePayment: Boolean
  },

  data() {
    return {
      showModalityInputs: false,
      showPaymentForm: false,
      showPixTooltip: false,
      pixCode: null,
      noPixHotelPaymentForms: [],
      hasPix: null
    }
  },

  computed: {
    disableOnlyPix() {
      if (this.fluctuationData.somentePix || this.blockPixEdition) {
        return true
      }

      return false
    },

    hidePaymentForm() {
      let hasPrePaid = false
      let hasWarranty = false

      if (
        this.fluctuationData.meiosPagamento &&
        this.fluctuationData.meiosPagamento?.length
      ) {
        this.fluctuationData.meiosPagamento.forEach((meioPagamento) => {
          if (meioPagamento.tipoPagamento === 2) {
            hasPrePaid = true
          } else if (meioPagamento.tipoPagamento === 1) {
            hasWarranty = true
          }
        })
      }

      switch (true) {
        case this.fluctuationData.somentePix:
          return false
        case this.hotelPaymentType !== 2 && !hasPrePaid:
          return false
        case hasPrePaid && hasWarranty:
          return false
        case hasPrePaid:
          return true
        case hasWarranty:
          return false
        default:
          return true
      }
    },

    /**
     * Exibe a seleção de pagamento com PIX apenas se
     * o método de pagamento selecionado da tarifa OU
     * do hotel for PRÉ PAGAMENTO
     */
    showPixSelection() {
      return (
        this.pixRate &&
        (this.fluctuationData?.meiosPagamento?.some(
          (item) => item.tipoPagamento === 2
        ) ||
          this.hotelPaymentType === 2)
      )
    }
  },

  watch: {
    showPixSelection(newVal) {
      if (newVal === false) {
        this.fluctuationData.habilitarPagamentoPix = false
        this.fluctuationData.somentePix = false
      }
    }
  },

  async created() {
    if (this.hotelPaymentForms) {
      if (!this.pixCode) {
        this.pixCode = this.hotelPaymentForms.find(
          (option) => option.nome === 'Pix'
        )?.codigo
      }

      this.noPixHotelPaymentForms = this.hotelPaymentForms.filter(
        (item) => item.codigo !== this.pixCode && item.exclusivoTarifa !== false
      )

      if (
        this.fluctuationData?.formasPagamento &&
        this.fluctuationData?.formasPagamento?.length > 0
      ) {
        this.hasPix = this.fluctuationData?.formasPagamento?.filter(
          (item) => item === this.pixCode
        )
      } else {
        this.hasPix = null
      }

      if (this.blockPixEdition || (this.hasPix && this.hasPix?.lenght > 0)) {
        this.fluctuationData.habilitarPagamentoPix = true
        if (!this.hasPix && this.pixCode) {
          this.fluctuationData?.formasPagamento?.push(this.pixCode)
        }
      }

      if (
        this.fluctuationData.formasPagamentoExclusivoFlutuacao &&
        this.hasPix &&
        this.hasPix?.length > 0 &&
        this.hasPix?.length === this.fluctuationData?.formasPagamento?.length
      ) {
        this.fluctuationData.somentePix = true
      } else if (
        this.fluctuationData?.formasPagamento?.length > 0 &&
        this.hasPix?.length !== this.fluctuationData?.formasPagamento?.length
      ) {
        this.showPaymentFormHandler()
      }
    }

    if (this.fluctuationData.meiosPagamento?.length) {
      this.showModalityInputs = true
    }
  },

  methods: {
    closePaymentInputs() {
      this.showPaymentForm = false

      if (this.hasPix) {
        this.fluctuationData.formasPagamento = this.fluctuationData.formasPagamento.filter(
          (item) => item === this.pixCode
        )
      } else {
        this.fluctuationData.formasPagamento = []
      }

      if (
        this.fluctuationData.formasPagamentoExclusivoFlutuacao &&
        !this.fluctuationData.somentePix
      ) {
        this.fluctuationData.formasPagamentoExclusivoFlutuacao = false
      }
    },

    async pixCheckboxHandler($event) {
      if (
        !this.fluctuationData.formasPagamento ||
        !this.fluctuationData?.formasPagamento?.length
      ) {
        this.fluctuationData.formasPagamento = []
      }

      if ($event) {
        this.fluctuationData.formasPagamento.push(this.pixCode)
      } else {
        this.fluctuationData.formasPagamento = this.fluctuationData.formasPagamento.filter(
          (item) => item !== this.pixCode
        )
      }
    },

    onlyPixCheckboxHandler($event) {
      if ($event) {
        this.fluctuationData.formasPagamentoExclusivoFlutuacao = false
        this.fluctuationData.formasPagamento = this.fluctuationData.formasPagamento.filter(
          (item) => item === this.pixCode
        )
      } else {
        this.fluctuationData.formasPagamentoExclusivoFlutuacao = false
        this.fluctuationData.formasPagamento = [this.pixCode]
      }
    },

    showPaymentFormHandler() {
      this.showPaymentForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.billing-payment-methods {
  min-width: 900px;
  .form {
    &--subtitle {
      font-size: font-size('size-small');
      font-weight: font-weight('weight-normal');
      color: pmw-colors(grey-80);
      line-height: 21px;
      margin-top: 8px;
      margin-bottom: 30px;

      &__small {
        margin-bottom: 0;
      }

      &__link {
        color: pmw-colors(blue-100);
        max-width: 150px;
        line-height: 18px;
        cursor: pointer;
        text-decoration: underline;

        &:hover {
          color: pmw-colors(blue-80);
        }
      }
    }

    &--button {
      width: 250px;
      margin-top: 24px;
    }

    &--input {
      &__checkbox {
        width: 265px;
        max-width: 265px;

        &__big {
          width: 350px;
          max-width: 350px;
        }
      }

      /** Alterar cores novas do select */
      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }

      &__select {
        width: 250px;
        max-width: 250px;

        &.error {
          ::v-deep {
            .pmw-select--button {
              border-bottom-color: pmw-colors('error-100');
              border-bottom-width: 2px;
            }
          }
        }
      }

      &__datepicker {
        margin-right: 10px;

        ::v-deep {
          .pmw-input--field:focus {
            border-color: pmw-colors(blue-100);
          }

          .pmw-input--clear {
            color: pmw-colors(blue-100);
          }
        }
      }
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 28px;

      &__margin {
        margin-top: 20px;
      }
    }

    &--title {
      margin-bottom: 8px;
      min-width: auto;
      display: inline-flex;

      &__spacing {
        margin-top: 16px;
      }

      &__size {
        width: auto;
      }
    }
  }

  .pix-payment {
    display: inline-block;

    position: relative;

    &--rate-pix {
      display: flex;
    }

    &--warning {
      margin-top: 10px;
    }
  }
}
</style>
